import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ROLES } from "@/constants/roles";
import LoginPage from "@/pages/auth/login";
import MainLayout from "@/layouts/MainLayout";
import Dashboard from "@/pages/dashboard";

import MemberManagement from "@/pages/member";
import InviteManagement from "@/pages/invite";
import CoursesManagement from "@/pages/courses";
import WordManagement from "@/pages/words";

import Settings from "@/pages/settings";
import Layout from "@/layouts/Layout";

import { ProtectedRoute } from "@/lib/ProtectedRoute";
import ForbiddenPage from "@/pages/error/403";
import NotFoundPage from "@/pages/error/404";
import CommoditiesManagement from "@/pages/commodities";
import ActivitiesManagement from "@/pages/activities";
import CodeManagement from "@/pages/codes"
import OrderManagement from "@/pages/orders"
import CodeDetail from "@/pages/codes/detail";
import CourseDetail from "@/pages/courses/detail";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* 公开路由 */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />

          {/* 受保护的路由 */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            {/* 默认重定向到仪表板 */}
            <Route index element={<Navigate to="/dashboard" replace />} />

            {/* 仪表板 - 所有登录用户可访问 */}
            <Route path="dashboard" element={<Dashboard />} />

            {/* 用户管理 - 仅管理员可访问 */}
            <Route
              path="members"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="index" replace />} />
              <Route path="index" element={<MemberManagement />} />
            </Route>

            {/* 邀请管理 - 仅管理员可访问 */}
            <Route
              path="invite"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="index" replace />} />
              <Route path="index" element={<InviteManagement />} />
            </Route>

            {/* 课程管理 - 仅管理员可访问 */}
            <Route
              path="courses"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="index" replace />} />
              {/* 课程列表 */}
              <Route path="index" element={<CoursesManagement />} />
              {/* 课程详情 */}
              <Route path="detail" element={<CourseDetail />} />
            </Route>

            {/* 单词管理 - 仅管理员可访问 */}
            <Route
              path="words"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="index" replace />} />
              <Route path="index" element={<WordManagement />} />
            </Route>
            {/* 商品管理 - 仅管理员可访问*/}
            <Route
                path="commodities"
                element={
                  <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                    <Layout />
                  </ProtectedRoute>
                }
            >
              <Route index element={<Navigate to="index" replace />} />
              <Route path="index" element={<CommoditiesManagement />} />
            </Route>
            
            {/* 活动管理 - 仅管理员可访问*/}
            <Route
              path="activities"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="index" replace />} />
              <Route path="index" element={<ActivitiesManagement />} />
            </Route>
            {/* 兑换码管理  -仅管理员可访问 */}
            <Route
              path="codes"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="index" replace />} />
              <Route path="index" element={<CodeManagement />} />
              {/* 兑换码详情 */}
              <Route path="detail" element={<CodeDetail />} />
            </Route>

            {/* 订单管理  -仅管理员可访问 */}
            <Route
              path="orders"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="index" replace />} />
              <Route path="index" element={<OrderManagement />} />
            </Route>

            {/* 系统设置 - 仅管理员可访问 */}
            <Route
              path="settings"
              element={
                <ProtectedRoute requiredRoles={[ROLES.ADMIN]}>
                  <Settings />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* 未匹配的路径重定向到 404 */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRouter;
